import React, { useState } from 'react';
import {
    AlertViewModel,
    ALERT_SEVERITY_INFO,
    ALERT_SEVERITY_PREVENT,
    ALERT_SEVERITY_WARN,
} from '../../store/alerts/types';
import { FontSizes } from '@uifabric/fluent-theme/lib/fluent/FluentType';
import { NeutralColors } from '@uifabric/fluent-theme/lib/fluent/FluentColors';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { Icon } from '@fluentui/react/lib/Icon';
import Action from 'titus-ts/dist/js/Util/Actions/Action';
import { DIALOG_REMEDIATE_TYPE } from '../../services/dialogService';
import { AnimationStyles, mergeStyles } from '@fluentui/react/lib/Styling';
import HtmlSanitizer from '../../office/validation/HtmlSanitizer';

type AlertProps = {
    alertViewModel: AlertViewModel;
    remediateAlerts: (actions: Action[], remediatetype: DIALOG_REMEDIATE_TYPE) => Promise<void>;
    isHostOutlook: boolean;
};

const Alert = (props: AlertProps) => {
    const { alertViewModel, remediateAlerts, isHostOutlook } = props;
    const [isExpanded, setIsExpanded] = useState(alertViewModel.isExpanded);
    const [isRemediable, setIsRemediable] = useState(alertViewModel.isRemediable);
    const sanitizedHtmlDescription = HtmlSanitizer.SanitizeHtml(alertViewModel.description ?? '');

    return (
        <div style={{ marginTop: '8px', marginBottom: '8px' }}>
            <div
                style={{
                    display: 'flex',
                    userSelect: 'none',
                    cursor: 'pointer',
                }}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div style={{ width: '16px', marginTop: '2px', marginRight: '2px' }}>
                    {alertViewModel.severity === ALERT_SEVERITY_INFO && (
                        <TooltipHost content="Information">
                            <Icon iconName="Info" style={{ fontSize: '16px', color: 'blue' }} />
                        </TooltipHost>
                    )}
                    {alertViewModel.severity === ALERT_SEVERITY_WARN && (
                        <TooltipHost content="Warning">
                            <Icon iconName="Warning" style={{ fontSize: '16px', color: 'orange' }} />
                        </TooltipHost>
                    )}
                    {alertViewModel.severity === ALERT_SEVERITY_PREVENT && (
                        <TooltipHost content="Prevent">
                            <Icon iconName="ErrorBadge" style={{ fontSize: '16px', color: 'red' }} />
                        </TooltipHost>
                    )}
                </div>
                <div
                    style={{
                        cursor: 'pointer',
                        width: '16px',
                        marginTop: '2px',
                        marginRight: '8px',
                    }}
                >
                    {isExpanded && <Icon iconName="ChevronDown" />}
                    {!isExpanded && <Icon iconName="ChevronRight" />}
                </div>
                <div
                    style={{
                        fontSize: FontSizes.size16,
                        color: NeutralColors.black,
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-word',
                        whiteSpace: isExpanded ? 'normal' : 'nowrap',
                    }}
                >
                    {alertViewModel.title}
                </div>
            </div>

            {isExpanded && (
                <div
                    className={mergeStyles(AnimationStyles.scaleUpIn100, {
                        fontSize: FontSizes.size14,
                        color: NeutralColors.black,
                        marginLeft: '24px',
                        marginTop: '8px',
                        marginBottom: '16px',
                        wordBreak: 'break-word',
                    })}
                >
                    {<div dangerouslySetInnerHTML={{ __html: sanitizedHtmlDescription ?? '' }}></div>}
                </div>
            )}
            {isRemediable && (
                <div style={{ marginLeft: '42px', marginTop: '8px' }}>
                    <DefaultButton
                        text="Remove Recipients"
                        onClick={() => {
                            remediateAlerts(alertViewModel.alerts, 'DialogRemediate');
                            setIsRemediable(!isRemediable);
                        }}
                    />
                </div>
            )}
            <hr
                style={{
                    color: 'lightgrey',
                    backgroundColor: 'lightgrey',
                    height: '0.2px',
                    border: 'none',
                    width: isHostOutlook ? '93%' : '95%',
                }}
            />
        </div>
    );
};

export default Alert;
